export default "__VITE_ASSET__BoFWIZt6__"